export const IS_PROD = process.env.NODE_ENV === 'production';

export const log = (...args: any[]) => {
  if (IS_PROD) return;
  console.log(...args);
};
